import { TResourceGroup, TResourceGroupParams } from 'types/resourceGroup';

import { CRMAPIBase } from '@api/crmApiBase';
import { RequestResult } from '@api/responseModels/requestResult';
import { ResourceGroupResp } from '@api/responseModels/resource/resourceResponseGroup';

export class ResourceAdminGroup extends CRMAPIBase {
    async getAdminBaseResourceGroupList(): // params: TResourceGroupParams
    Promise<RequestResult<ResourceGroupResp>> {
        const result = await this.get<ResourceGroupResp>(`/admin/base-resource-groups`);
        return result;
    }
    async getAdminBaseResourceGroup(params: {
        id: number;
    }): Promise<RequestResult<ResourceGroupResp>> {
        const result = await this.get<ResourceGroupResp>(
            `/admin/base-resource-groups/${params.id}`
        );
        return result;
    }
    async createAdminBaseResourceGroup(
        params: TResourceGroupParams
    ): Promise<RequestResult<ResourceGroupResp>> {
        const result = await this.post<ResourceGroupResp>(`/admin/base-resource-groups`, params);
        return result;
    }
    async updateAdminBaseResourceGroup(
        params: TResourceGroup
    ): Promise<RequestResult<ResourceGroupResp>> {
        const result = await this.put<ResourceGroupResp>(
            `/admin/base-resource-groups/${params.id}`,
            params
        );
        return result;
    }
}
